import { render, staticRenderFns } from "./AmountSelector.vue?vue&type=template&id=20bb0a08"
import script from "./AmountSelector.vue?vue&type=script&lang=js"
export * from "./AmountSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports